import React from "react";
import { LoginFormProps, LoginFormSubmit } from "../../declarations/form";
import AppCopy from "../../copy/AppCopy";
import { Formik } from "formik";
import { LoginValidationScheme } from "../../validations/schemes";
import Images from "../../images/Images";

function LoginForm({ onSubmit }: LoginFormProps) {
  const handleSubmit = (data: LoginFormSubmit) => {
    onSubmit(data);
  };

  const {
    emailPlaceholder,
    emailTitle,
    passwordPlaceholder,
    passwordTitle,
    submitButtonText,
  } = AppCopy.form.loginForm;

  return (
    <div className={Classnames.container}>
      <div className={Classnames.logoBadge}>
        <img src={Images.logo} alt="BossCar" className={Classnames.logo} />
      </div>
      <div className={Classnames.heading}>
        <h1 className={Classnames.title}>Dashboard sign in</h1>
        <p className={Classnames.description}>
          Use your staff or administrator account.
        </p>
      </div>
      <Formik
        initialValues={{ email: "", password: "" }}
        validationSchema={LoginValidationScheme}
        onSubmit={(values, action) => {
          handleSubmit(values);
        }}
      >
        {({ handleChange, handleSubmit, values, errors, touched }) => (
          <form className={Classnames.form} onSubmit={handleSubmit}>
            <label className={Classnames.label} htmlFor="dashboard-email">
              {emailTitle}
            </label>
            <input
              id="dashboard-email"
              type="email"
              autoComplete="email"
              value={values.email}
              placeholder={emailPlaceholder}
              onChange={handleChange("email")}
              className={Classnames.input}
            />
            {errors.email && touched.email && (
              <span className={Classnames.error}>{errors.email}</span>
            )}
            <label className={Classnames.label} htmlFor="dashboard-password">
              {passwordTitle}
            </label>
            <input
              id="dashboard-password"
              type="password"
              autoComplete="current-password"
              value={values.password}
              placeholder={passwordPlaceholder}
              onChange={handleChange("password")}
              className={Classnames.input}
            />
            {errors.password && touched.password && (
              <span className={Classnames.error}>{errors.password}</span>
            )}
            <div className={Classnames.buttonContainer}>
              <button
                className={Classnames.button}
                type="submit"
              >
                {submitButtonText}
              </button>
            </div>
          </form>
        )}
      </Formik>
    </div>
  );
}

export default LoginForm;

const Classnames = {
  container:
    "flex w-full max-w-md flex-col rounded-2xl border border-slate-200 bg-white p-6 shadow-sm sm:p-8",
  logoBadge:
    "flex h-10 w-fit items-center rounded-lg bg-slate-950 px-3",
  logo: "h-5 w-auto object-contain",
  heading: "mb-5 mt-6",
  title: "text-2xl font-bold tracking-tight text-primaryText",
  description: "mt-1 text-sm text-secondaryText",
  form: "flex flex-col",
  label: "mt-3 text-sm font-semibold text-primaryText",
  input:
    "my-1 h-11 w-full rounded-lg border border-slate-300 bg-white px-3 text-sm text-primaryText placeholder:text-slate-400",
  buttonContainer: "flex w-full items-center justify-center",
  button:
    "mt-5 h-11 w-full cursor-pointer rounded-lg bg-primary text-sm font-bold text-white transition-opacity hover:opacity-90",
  error: "text-xs text-error",
};
